// import React from "react";
// import { Link } from "react-router-dom";
// import { ArrowUpRight } from "lucide-react";

// const CornerSvg = () => (
//   <svg
//     className="cat-card-corner"
//     viewBox="0 0 36 36"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path d="M2 2h32v32" stroke="white" strokeWidth="1.2" />
//     <path
//       d="M2 2v32h32"
//       stroke="white"
//       strokeWidth="0.5"
//       strokeDasharray="3 3"
//     />
//     <circle cx="18" cy="18" r="5" stroke="white" strokeWidth="0.8" />
//   </svg>
// );

// function Card({ item, featured = false, variant = "regular", cardRef }) {
//   if (!item) return null;

//   const hasVideo = !!item.video;
//   const slug = item.slug || item.slugPath;

//   // Determine CSS class
//   const sizeClass = featured
//     ? "cat-card--featured"
//     : variant === "list"
//       ? "cat-card--list"
//       : "cat-card--regular";

//   return (
//     <>
//       <Link
//         to={`/categories/${slug}`}
//         className={`cat-card ${sizeClass}`}
//         ref={cardRef}
//       >
//         {/* Background media */}
//         {hasVideo ? (
//           <video
//             className="cat-card-video"
//             autoPlay
//             muted
//             loop
//             playsInline
//             aria-hidden="true"
//           >
//             <source src={item.video} type="video/mp4" />
//           </video>
//         ) : (
//           item.image && (
//             <img
//               src={item.image}
//               alt={item.name || item.title}
//               className="cat-card-image"
//               loading="lazy"
//             />
//           )
//         )}

//         {/* Overlay */}
//         <div className="cat-card-overlay" aria-hidden="true" />

//         {/* Corner ornament (featured only) */}
//         {featured && <CornerSvg />}

//         {/* Content */}
//         <div className="cat-card-content">
//           {item.label && <span className="cat-card-tag">{item.label}</span>}
//           <h3 className="cat-card-title">{item.name || item.title}</h3>
//           <div
//             style={{
//               color: "#fff",
//               border: "1px solid rgba(255,255,255,0.3)",
//               borderRadius: "50%",
//               padding: "10px",
//             }}
//           >
//             <ArrowUpRight size={18} />
//           </div>
//         </div>
//       </Link>
//     </>
//   );
// }

// export default Card;

import { ArrowUpRight } from "lucide-react";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Card = ({item}) => {
  const navigate = useNavigate();
  return (
    <div
      key={item.id}
      className="eth-static-card"
      onClick={() => navigate(`/categories/${item?.slug}`)}
    >
      {item?.video ? (
        <video autoPlay muted loop playsInline>
          <source src={item?.video} type="video/mp4" />
        </video>
      ) : (
        <img
          src={item?.image}
          alt={item?.name}
          className="eth-static-card-image"
          loading="lazy"
        />
      )}

      <div className="eth-static-overlay">
        <div className="d-flex justify-content-between align-items-end">
          <div>
            <h3 className="eth-cat-name">{item?.name}</h3>
          </div>
          <div className="eth-cat-cta">
            <ArrowUpRight size={18} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
